import gql from 'graphql-tag';

export const dokkioErrorFragment = gql`
  fragment dokkioErrorFragment on DokkioError {
    dokkioClass
    errorCode
    errorMessage
    errorStack
    errorStatus
    errorVariables
  }
`;
export default dokkioErrorFragment;
